<div id="material-parent-container">
  <router-outlet></router-outlet>
</div>
